import React from "react"
import "./home.scss"
import {
  Chart,
  Featured,
  Navbar,
  Sidebar,
  HomeTable,
  Widget,
} from "../../components"

function Home() {
  return (
    <>
      <div className="home">
        <Sidebar />
        <div className="homeContainer">
          <Navbar />
          <div className="widgets">
            <Widget type="user" />
            <Widget type="order" />
            <Widget type="earning" />
            <Widget type="balance" />
          </div>
          <div className="charts">
            <Featured />
            <Chart aspect={3 / 1} title="Last 6 Months (Revenue)" />
          </div>

          <div className="listContainer">
            <div className="listTitle">Latest Transections</div>
            <HomeTable />
          </div>
        </div>
      </div>
    </>
  )
}

export default Home
